import useData from 'store/useData';
// get badges item
export const getBadgesItems = async (badges: any) => {
  const data = useData.getState().badges;
  const badgesItems = data?.filter((item: any) => badges.includes(item._id));
  return badgesItems;
};
